export default "__VITE_ASSET__Beea6xCj__"